import MenuSection from 'components/layout/header/MenuSection';
import Separator from 'components/Separator';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { colors } from 'utils/constants';
import ArcadeColourPageSection from '../ArcadeColourPageSection';
import { aLittleLostContent } from './content';

const ALittleLostSection = observer(() => {
  const [faqContent, setFaqContent] =
    useState<{ question: string; answer: JSX.Element }[]>(aLittleLostContent);

  return (
    <ArcadeColourPageSection>
      <div className="aLittleLostSection fullWidth flexCentered">
        <h2 className="header">A little lost?</h2>
        <p className="subheader">
          Not too sure how it all works?
          <br />
          Check out some FAQ’s below or{' '}
          <a href="mailto:hello@daymade.co.uk">get in touch</a>
        </p>

        <div className="qAndASection">
          <>
            {faqContent.map((item, idx) => {
              return (
                <React.Fragment key={idx}>
                  <MenuSection
                    titleComponent={
                      <p className="faqQuestion">{item.question}</p>
                    }
                  >
                    <p className="faqAnswer">{item.answer}</p>
                  </MenuSection>
                  {idx < faqContent.length - 1 && (
                    <Separator margin={'1.4em'} />
                  )}
                </React.Fragment>
              );
            })}
          </>
        </div>
      </div>

      <style jsx>
        {`
          .header {
            font-family: 'Press Start 2P', 'Montserrat', sans-serif !important;
            font-size: 1.5em;
            font-weight: 400;
            text-shadow: 2px 2px #ffffff;
            letter-spacing: 0;
          }

          .subheader {
            font-size: 1em;
          }

          .aLittleLostSection a {
            text-decoration: underline;
          }

          .qAndASection {
            width: 100%;
            margin-top: 1em;
          }

          .aLittleLostSection p.faqQuestion {
            text-transform: none;
            font-weight: 800;
            font-size: 1em;
            letter-spacing: 0;
            text-align: left;
          }

          .faqAnswer {
            text-align: left;
            padding-bottom: 0.5em;
          }

          :global(.aLittleLostSection .separator) {
            background-color: ${colors.primaryBrandGray};
          }

          :global(.aLittleLostSection .sectionTitle.noSelect) {
            padding-left: 0;
            padding-right: 0;
            text-align: left;
          }

          @media (min-width: 700px) {
            .header {
              font-size: 1.7rem;
            }

            .subheader {
              font-size: 1.5em;
            }

            .aLittleLostSection p.faqQuestion {
              font-size: 1.5em;
            }
          }
        `}
      </style>
    </ArcadeColourPageSection>
  );
});

export default ALittleLostSection;
